import React from 'react';
import styled from 'styled-components';

import BankrollModalLayout from './BankrollModalLayout';

const ErrorText = styled.div`
  line-height: normal;
  font-size: var(--medium);
  line-height: normal;
  color: var(--error);
`;

export default function BankrollInvalidModal({
  onClose,
  quantity,
}: {
  onClose: () => void;
  quantity?: string;
}) {
  return (
    <BankrollModalLayout quantity={quantity} onClose={onClose}>
      <ErrorText>This promotion is no longer valid</ErrorText>
      {/* // : bankroll.revokedAt ? (
      //   <ErrorText>The promotional offer expired<br />on {formatDateTime(bankroll.revokedAt, { hours: false })}</ErrorText>
      // ) : bankroll.redeemedAt ? (
      //   <ErrorText>The promotional offer was used<br />on {formatDateTime(bankroll.redeemedAt, { hours: false })}</ErrorText>
      // ) */}
    </BankrollModalLayout>
  );
}
